import React from 'react';
import { hasPermission, getUserRole, getCurrentSession, ROLES } from '../utils/roleManager';

const PermissionGuard = ({ 
  children, 
  permission, 
  roleLevel, 
  fallback = null, 
  username = null 
}) => {
  // Get username from session if not provided
  const currentSession = getCurrentSession();
  const userToCheck = username || currentSession?.username || localStorage.getItem('chess_player_name');
  
  if (!userToCheck) {
    return fallback;
  }

  // Check permission if specified
  if (permission && !hasPermission(userToCheck, permission)) {
    return fallback;
  }

  // Check role level if specified
  if (roleLevel) {
    const userRole = getUserRole(userToCheck);
    const roleObj = Object.values(ROLES).find(role => role.id === userRole);
    if (!roleObj || roleObj.level < roleLevel) {
      return fallback;
    }
  }

  return children;
};

export default PermissionGuard;